import { URL } from '@api/services/axios';
import { HttpTransportType, HubConnection, HubConnectionBuilder } from '@microsoft/signalR';
import { useEffect, useState } from "@wordpress/element";

const gerarGroupName = () => `grupo-ia-${crypto.randomUUID()}`;

function NotificationHub({ setConnectionHub, setParagrafoGerado, prompt }) {
  const [connection, setConnection] = useState<HubConnection | null>(null);
  const [groupName] = useState(gerarGroupName);

  useEffect(() => {
    const conn = new HubConnectionBuilder()
      .withUrl(`${URL}/notification-hub`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .build();

    setConnection(conn);
  }, []);

  useEffect(() => {
    if (connection) {

      connection.on("EnviarParagrafoGerado", (paragrafo) => {
        setParagrafoGerado(paragrafo);

        //console.log("Parágrafo recebido:", paragrafo);
      });

      connection.start()
        .then(async () => {
          await connection.invoke("EntrarGrupo", groupName);

          setConnectionHub(groupName);

          //console.log("Conexão estabelecida e grupo criado:", groupName);

        })
        .catch((err) => {
          console.error("Erro ao conectar:", err);
        });

      connection.onreconnected(async () => {
        //console.log("Reconectado!");
        await connection.invoke("EntrarGrupo", groupName);
      });

      return () => {
        connection.stop().then(() => {
          //console.log("Conexão encerrada");
        });
      };
    }
  }, [connection, prompt, groupName]);

  return null;
}

export default NotificationHub;